export const Role = {
  ADMIN: 'ADMIN',
  OWNER: 'OWNER',
  BRAND_MANAGER: 'BRAND_MANAGER',
  AGENCY: 'AGENCY',
  SALESMAN: 'SALESMAN',
  SHIPPER: 'SHIPPER',
  TELESALES: 'TELESALES',
  WAREHOUSE_KEEPER: 'WAREHOUSE_KEEPER',
  DEBT_ACCOUNTANT: 'DEBT_ACCOUNTANT',
}